export enum ReceiveStateType
{
	URL
}
